import type { CreateCollectResponse } from '@/api/Collect/types.ts'
import { isAxiosError } from 'axios'

export function resolveAlreadyRegisteredCollect(
  error: unknown
): CreateCollectResponse | undefined {
  if (!isAxiosError(error) || error.response?.status !== 409) return undefined
  const collectId = (error.response.data as { collectId?: unknown } | undefined)
    ?.collectId
  if (
    typeof collectId === 'number' &&
    Number.isInteger(collectId) &&
    collectId > 0
  ) {
    return { id: collectId, alreadyRegistered: true }
  }
  return undefined
}
